/** useCookie 布尔值：避免 "false" 字符串被当作 truthy */
export const booleanCookieSerializer = {
  read: (value) => value === true || value === 'true',
  write: (value) => (value ? 'true' : 'false'),
}
